import queryString from "query-string";
const { r } = queryString.parse(window.location.search);

redirectFallback();

function redirectFallback() {
  // landed on start page with redirect declared
  if (r && location.pathname.includes("start")) {
    localStorage.setItem("targetID", r);
    return;
  }

  // landed on front-end page with redirect found in localStorage
  if (
    !document.body.classList.contains("page-template-page-start") &&
    !location.pathname.includes("wp-admin") &&
    !location.pathname.includes("pending-approval") &&
    localStorage.getItem("targetID")
  ) {
    const targetID = localStorage.getItem("targetID");

    // extract event / clip IDs
    const redirParams = targetID.split("-");
    const eventID = redirParams[0];
    const clipID = redirParams[1];

    // its a match
    if (eventID === WP.pageID) {
      localStorage.removeItem("targetID");
    }

    // its not a match
    else {
      localStorage.removeItem("targetID");
      if (clipID) {
        location.href = `${location.origin}/index.php?page_id=${eventID}&c=${clipID}`;
      } else {
        location.href = `${location.origin}/index.php?page_id=${eventID}`;
      }
    }
    return;
  }

  // ! Kill the redirect fallback in all other cases
  /**
   * admin pages
   * any front-end page other than start / event
   * start page when ?r not present
   * event page with no targetID present
   * etc
   */
  localStorage.removeItem("targetID");
}
